export default __webpack_public_path__ + "static/example-web-5d35b0c0b05ae39c77faddacfb62e9b5.png";